<template>
    <v-list-item id="sf-SupportButton" class="text-left" title="Support" prepend-icon="mdi-help-circle-outline"
        append-icon="mdi-chevron-right" link nav>

        <v-menu activator="parent" location="end" eager>
            <v-list density="compact">
                <v-list-item id="sf-TutorialButton" title="Tips" prepend-icon="mdi-lightbulb-on-outline" link />
            </v-list>
        </v-menu>

    </v-list-item>
</template>

<script>

export default {
    name: 'SupportMenu',
    data() {
        return {
        }
    },
}
</script>